export class StripePayout {
    public currency: string;
    public amount: number;

    public toString(): string{
        return this.amount.toString() + ' ' + this.currency.toUpperCase();
    }

    constructor(amount: number, currency: string) {
        this.amount = amount;
        this.currency = currency;
    }

}
